
import { NgxSpinnerService } from 'ngx-spinner';
import { Injectable } from '@angular/core';
import { UtilService } from './util.service';
import { AppSettings } from './AppSettings';
import { CommonValues } from './commonValues';
import { NotificationService } from './notification.service';
import * as XLSX from 'xlsx';
import { BehaviorSubject, Observable, of, throwError, timer } from 'rxjs';
import { HttpHeaders, HttpClient, HttpBackend, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, mergeMap, retryWhen, take } from 'rxjs/operators';
import { GigsumoConstants } from './GigsumoConstants';



if (localStorage.getItem('userId') == null || localStorage.getItem('userId') == '') {
  const id = '';
} else {
  const id = localStorage.getItem('userId');
}

// const httpOptions = {
//   headers: new HttpHeaders({
//     'Content-Type': AppSettings.HTTP_CONTENT_TYPE,
//     'Access-Control-Allow-Origin': AppSettings.HTTP_ACCESS_CONTROL_ALLOW_ORIGIN,
//     //'userId': id
//   })
// };

const commonHeader = {
  headers: new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': '*',
    "Access-Control-Allow-Headers": "Origin, X-Requested-ith, Content-Type, Accept, Authorization"
  })
};
@Injectable({
  providedIn: 'root'
})

export class ApiService {
  // errorCount: number;
  private byPassCall: HttpClient
  private loadAPIcallValueSubject = new BehaviorSubject<boolean>(true);
  loadAPIcallValue$ = this.loadAPIcallValueSubject.asObservable();
  httpHeaders: { headers: HttpHeaders; };
  constructor(
    private http?: HttpClient, private util?: UtilService, private commonvalues?: CommonValues, private spinner?: NgxSpinnerService, private byPassReq?: HttpBackend, private notification?: NotificationService) {
    this.byPassCall = new HttpClient(byPassReq);
    this.httpHeaders = {
      headers: new HttpHeaders().set('Platform', 'GIGSUMO_APP'),
    };
  }

  // login(u, User): Observable<any> {
  //   const url = AppSettings.ServerUrl + u;
  //   return this.http.post<any>(url , User).pipe(
  //     retry(2),
  //     // return this.http.post<any>(url , User , commonHeader).pipe(
  //     catchError(this.handleError1));
  // }

  userLogin(u, User): Observable<any> {

    let url = AppSettings.ServerUrl + u;
    var credentials = btoa(User.username + ":" + User.password);
    const httpOptionslogin = {
      headers: new HttpHeaders({ 'Authorization': 'Basic ' + credentials })
    };

    return this.http.post<any>(url, {}, httpOptionslogin).pipe();
  }


  googleLogin(u: string, token: string): Observable<any> {
    let url = AppSettings.ServerUrl + u;
    const credentials = token;
    const header = {
      headers: new HttpHeaders({ 'Authorization': 'Basic ' + credentials })
    };

    return this.http.get<any>(url, header).pipe();
  }




  creditPurches(u, commonHeader): Observable<any> {
    const url = AppSettings.ServerUrl + u;
    return this.http.post<any>(url, {}, commonHeader).pipe();
  }


  create(u, User, errorMessage?: string): Observable<any> {
    const url = AppSettings.ServerUrl + u;
    return this.http.post<any>(url, User , {headers : this.httpHeaders.headers}).pipe(
      catchError(this.handleError<any>(errorMessage))
    )
  }

  /**
   * Fetch ranking details with automatic retry for PROCESSING status
   * Handles AI processing delays by retrying automatically when status is PROCESSING
   *
   * AWS Lambda timeout is set to 90s for AI processing
   * Default: 3 retries with 25s delay = ~75s total (fits within 90s timeout)
   *
   * @param payload - Request payload for fetchJobRankingDetails API
   * @param maxRetries - Maximum number of retry attempts (default: 3)
   * @param delayMs - Delay in milliseconds between retries (default: 25000ms = 25s)
   * @returns Observable with ranking details or error
   */
  fetchRankingDetailsWithRetry(payload: any, maxRetries: number = 3, delayMs: number = 25000): Observable<any> {
    return this.create('jobs/fetchJobRankingDetails', payload).pipe(
      mergeMap(res => {
        // Check if response indicates AI is still processing
        if (res.code === '00000' && res.data?.status === 'PROCESSING') {
          console.log('⏳ AI is processing, will retry...', {
            eventId: res.data.eventId,
            message: res.data.message,
            status: res.data.status
          });

          // Throw a special error to trigger retry mechanism
          return throwError(() => ({
            isProcessing: true,
            message: res.data.message || 'AI Engine is analyzing. Results will be available shortly.',
            eventId: res.data.eventId,
            jobId: res.data.jobId,
            candidateId: res.data.candidateId
          }));
        }

        // Data is ready - return successful response
        console.log('✅ Ranking data ready:', res.data?.source);
        return of(res);
      }),
      retryWhen(errors =>
        errors.pipe(
          mergeMap((error, retryAttempt) => {
            // Only retry if it's a processing error and we haven't exceeded max retries
            if (error.isProcessing && retryAttempt < maxRetries) {
              const attemptNumber = retryAttempt + 1;
              console.log(`🔄 Retry attempt ${attemptNumber}/${maxRetries} - waiting ${delayMs}ms...`);

              // Return timer to wait before retry
              return timer(delayMs);
            }

            // Max retries reached - return timeout error
            if (error.isProcessing && retryAttempt >= maxRetries) {
              console.log('⏱️ Max retries reached. AI still processing.');
              return throwError(() => ({
                timeout: true,
                isProcessing: true,
                message: 'Analysis is taking longer than expected. Please try again in a moment.',
                attemptsExhausted: true,
                maxRetries: maxRetries
              }));
            }

            // Other errors - propagate them
            return throwError(() => error);
          }),
          take(maxRetries + 1) // Limit total retry attempts
        )
      ),
      catchError(error => {
        // Handle final errors
        console.error('❌ Ranking details fetch error:', error);
        return throwError(() => error);
      })
    );
  }

  suggestionsWithRetry(url:any, payload: any, maxRetries: number = 3, delayMs: number = 25000): Observable<any> {
    // Check if searchAfterKey is present in payload - if yes, skip retry mechanism
    const hasSearchAfterKey = payload?.searchAfterKey !== null && payload?.searchAfterKey !== undefined;

    if (hasSearchAfterKey) {
      console.log('🔄 searchAfterKey present in payload - skipping retry mechanism');
      // Return direct API call without retry logic
      return this.create(url, payload);
    }

    return this.create(url, payload).pipe(
      mergeMap(res => {
        // Check if response indicates AI is still processing
        if (res.code === '00000' && (res.data?.jobList && res.data.jobList.length == 0) || (res.data?.candidateList && res.data.candidateList.length == 0)) {
          console.log('⏳ AI is processing, will retry...', {
            eventId: res.data.eventId,
            message: res.data.message,
            status: res.data.status
          });

          // Throw a special error to trigger retry mechanism
          return throwError(() => ({
            isProcessing: true,
            message: res.data.message || 'AI Engine is analyzing. Results will be available shortly.',
            eventId: res.data.eventId,
            jobId: res.data.jobId,
            candidateId: res.data.candidateId
          }));
        }

        // Data is ready - return successful response
        console.log('✅ Ranking data ready:', res.data?.source);
        return of(res);
      }),
      retryWhen(errors =>
        errors.pipe(
          mergeMap((error, retryAttempt) => {
            // Only retry if it's a processing error and we haven't exceeded max retries
            if (error.isProcessing && retryAttempt < maxRetries) {
              const attemptNumber = retryAttempt + 1;
              console.log(`🔄 Retry attempt ${attemptNumber}/${maxRetries} - waiting ${delayMs}ms...`);

              // Return timer to wait before retry
              return timer(delayMs);
            }

            // Max retries reached - return timeout error
            if (error.isProcessing && retryAttempt >= maxRetries) {
              console.log('⏱️ Max retries reached. AI still processing.');
              return throwError(() => ({
                timeout: true,
                isProcessing: true,
                message: 'Analysis is taking longer than expected. Please try again in a moment.',
                attemptsExhausted: true,
                maxRetries: maxRetries
              }));
            }

            // Other errors - propagate them
            return throwError(() => error);
          }),
          take(maxRetries + 1) // Limit total retry attempts
        )
      ),
      catchError(error => {
        // Handle final errors
        console.error('❌ Ranking details fetch error:', error);
        return throwError(() => error);
      })
    );
  }
  talentPoolWithRetry(url:any, payload: any, maxRetries: number = 3, delayMs: number = 25000): Observable<any> {
    // Check if searchAfterKey is present in payload - if yes, skip retry mechanism
    const hasSearchAfterKey = payload?.searchAfterKey !== null && payload?.searchAfterKey !== undefined;

    if (hasSearchAfterKey) {
      console.log('🔄 searchAfterKey present in payload - skipping retry mechanism');
      // Return direct API call without retry logic
      return this.create(url, payload);
    }

    return this.create(url, payload).pipe(
      mergeMap(res => {
        // Check if response indicates AI is still processing
        if (res?.candidateList && res.candidateList.length == 0) {
          console.log('⏳ AI is processing, will retry...', {
            message: res.message
          });

          // Throw a special error to trigger retry mechanism
          return throwError(() => ({
            isProcessing: true,
            message: res.message || 'AI Engine is analyzing. Results will be available shortly.',
          }));
        }

        // Data is ready - return successful response
        console.log('✅ Talent pool data ready');
        return of(res);
      }),
      retryWhen(errors =>
        errors.pipe(
          mergeMap((error, retryAttempt) => {
            // Only retry if it's a processing error and we haven't exceeded max retries
            if (error.isProcessing && retryAttempt < maxRetries) {
              const attemptNumber = retryAttempt + 1;
              console.log(`🔄 Retry attempt ${attemptNumber}/${maxRetries} - waiting ${delayMs}ms...`);

              // Return timer to wait before retry
              return timer(delayMs);
            }

            // Max retries reached - return timeout error
            if (error.isProcessing && retryAttempt >= maxRetries) {
              console.log('⏱️ Max retries reached. AI still processing.');
              return throwError(() => ({
                timeout: true,
                isProcessing: true,
                message: 'Analysis is taking longer than expected. Please try again in a moment.',
                attemptsExhausted: true,
                maxRetries: maxRetries
              }));
            }

            // Other errors - propagate them
            return throwError(() => error);
          }),
          take(maxRetries + 1) // Limit total retry attempts
        )
      ),
      catchError(error => {
        // Handle final errors
        console.error('❌ Ranking details fetch error:', error);
        return throwError(() => error);
      })
    );
  }

  exportToExcelWithStyling(data: any[], filename: string) {
    // Create a new workbook and worksheet
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Define custom styles (e.g., font color, size, and logo)
    const style = {
      font: { color: { rgb: 'FF0000FF' }, size: 14 },
      fill: { fgColor: { rgb: 'FFFF00FF' } },
      logo: 'assets/icon/gigsumologo_bigface.png',
    };

    // Apply styles to the worksheet
    worksheet['!cols'] = [{ wch: 20 }, { wch: 10 }, /* ...add more as needed */];
    worksheet['!margins'] = { left: 0.5, right: 0.5, top: 1, bottom: 1 };
    worksheet['!page'] = { sheetPr: { tabColor: { rgb: 'FFFF00FF' } } };

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // Create a Blob representing the XLSX file
    XLSX.writeFile(workbook, `${filename}.xlsx`);
  }

// Lamda Function URL

async lamdaFunctionsget(path,postvalue?:String): Promise<any> {

    const url = AppSettings.LAMDA_URL + path;
    return await fetch(url).then(result=>{
        return result.json();
    }).then(data =>{
      return data
    });
 }
 async lamdaFunctionsPost(path,data?:any): Promise<any> {
  const url = AppSettings.LAMDA_URL + path;
  const requestOptions = {
    method: "POST",
    body: JSON.stringify(data),
  };
  return await fetch( url, requestOptions).then(result=>{
      return result.json();
  }).then(data =>{
    return data
  });


}






getStripeSession(urls,authId) {
  const headers = {
    Authorization: `Bearer ${authId}`,
  };

  return this.http.get(urls, { headers });
}



  query(u: string, errorMessage?: string, bypassCache: boolean = false): Observable<any> {
    const url = AppSettings.ServerUrl + u;
    // When bypassCache is true, tag the request so HttpCacheInterceptor skips
    // the cache (read + write) — used to force fresh data right after a write.
    const headers = bypassCache
      ? this.httpHeaders.headers.set('X-Skip-Cache', 'true')
      : this.httpHeaders.headers;
    // if(adData.loaderAnderror){
    return this.http.get<any>(url , {headers}).pipe(
      catchError(this.handleError<any>(errorMessage)));
    // }else{
    //   return this.byPassCall.get<any>(url).pipe(
    //     );
    // }

  }

  /**
   * GET request that returns raw ArrayBuffer (for downloading files like PDFs)
   */
  queryBlob(u: string): Observable<ArrayBuffer> {
    const url = AppSettings.ServerUrl + u;
    return this.http.get(url, {
      headers: this.httpHeaders.headers,
      responseType: 'arraybuffer'
    }).pipe(
      catchError(this.handleError<ArrayBuffer>('File download failed'))
    );
  }

  queryPassval(u, data, errorMessage?: string): Observable<any> {
    const url = AppSettings.ServerUrl + u;
    return this.http.get<any>(url, data).pipe(
      catchError(this.handleError<any>(errorMessage))
    );
  }



  updatePut(u, secData, errorMessage?: string) {
    const url = AppSettings.ServerUrl + u;
    return this.http.put<any>(url, secData , {headers : this.httpHeaders.headers}).pipe(
      catchError(this.handleError<any>(errorMessage))
    );
  }



  delete(data, errorMessage?: string) {
    const url = AppSettings.ServerUrl + data;
    return this.http.delete<any>(url, data).pipe(
      catchError(this.handleError<any>(errorMessage))
    );
  }

  deleteWithPayload(path: string, body: any, errorMessage?: string) {
    const url = AppSettings.ServerUrl + path;
    return this.http.request<any>('DELETE', url, { body }).pipe(
      catchError(this.handleError<any>(errorMessage))
    );
  }



  AuthToken(u, auth): Observable<any> {
    const url = AppSettings.ServerUrl + u;
    return this.http.get<any>(url, auth);
  }

  AuthValidation(u, vaildation): Observable<any> {
    const url = AppSettings.ServerUrl + u;
    return this.http.post<any>(url, vaildation).pipe(
      // return this.http.post<any>(url , vaildation , commonHeader).pipe(
      catchError(this.handleError<any>('Token Validation Check'))
    );
  }


  onLogout() {
    const url = AppSettings.ServerUrl + 'home/logout';
    return this.http.post<any>(url, {}).pipe(
      catchError(this.handleError<any>('communityDetails'))
    );
  }


  logout() {
    // const url = AppSettings.ServerUrl + "sso/logout";
    let url = AppSettings.ServerUrl + "sso/logout?redirect_url=" + window.location.href;
    // //// console.log("url---- "+url);
    window.location.href = url;
    //  return this.http.get<any>(url).pipe(
    // );
  }
  // Message page upload with progress events: same URL base and headers as
  // messagePageService POST, but reports HttpEventType.UploadProgress so the
  // caller can render a live percentage. Used by the composer's paste/drop
  // file sending (message/send/upload).
  messagePageUpload(path: string, formData: FormData) {
    const url = AppSettings.ServerUrl + path;
    return this.http.post(url, formData, {
      headers: this.httpHeaders.headers,
      reportProgress: true,
      observe: 'events' as const
    });
  }

  // Message page services
  messagePageService(method: string, path: string, data?: any, upload?: any, operation?: any) {
    const url = AppSettings.ServerUrl + path;
    if (method === 'GET') {
      return this.http.get(url , {headers : this.httpHeaders.headers}).pipe(catchError(this.handleError<any>(operation)));
    } else if (method === 'POST') {
      return this.http.post(url, data, {headers : this.httpHeaders.headers}).pipe(catchError(this.handleError<any>(operation)));
    } else if (method === 'PUT') {
      return this.http.put(url, data, {headers : this.httpHeaders.headers}).pipe(catchError(this.handleError<any>(operation)));
    } else if (method === 'DELETE') {
      return this.http.delete(url).pipe(catchError(this.handleError<any>(operation)));
    }
  }

  // Error msg

  errorCount = 0
  public handleError<T>(operation, result?: T) {
    return (error: any): Observable<T> => {
      if (error.status === 500) {
        this.util.stopLoader()
        if (operation != undefined) {
          this.notification.error('Error', operation);
        }
        throw error;
      } else if (error.status === 0) {
        this.util.stopLoader()
        throw error;
      } else if (error.status === 400 || error.status === 401) {
        this.util.stopLoader();
        throw error;
      } else if (error.status === 404 || error.status === 440) {
        this.util.stopLoader()

        throw error;
      } else if (error.status === 303) {
        this.util.stopLoader()
        throw error;
      }
      return of(result as T);
    };
  }

  public handleErrorOld<T>(operation = 'operation', result?: T) {



    return (error: any): Observable<T> => {
      if (error.status === 0) {
        if (this.errorCount === 0) {
          this.notification.error('Server Error', 'Server is not reachable. Please contact system admin');
          this.errorCount++;
        }
      } else if (error.status === 401) {
        if (this.errorCount === 0) {
          this.notification.error('Timeout Error', 'Timeout error. Please try again');
          this.errorCount++;
          return;
        }
      } else if (error.status === 500 || error.status === 501) {
        if (this.errorCount === 0) {
          this.notification.error('Server Error', 'Internal Server Error. Please try again');
          this.errorCount++;
          return;
        }
      } else if (error.status === 400) {
        if (this.errorCount === 0) {
          this.notification.error('Bad Request', 'Bad request');
          localStorage.clear();
        }
      }
      return of(result as T);
    };
  }

  handleError1(error: HttpErrorResponse) {
    return throwError(error);
  }
  setLoadAPIcall(value: boolean) {
    this.loadAPIcallValueSubject.next(value);
  }

  getLoadAPIcall() {
    return this.loadAPIcallValueSubject.value;
  }

}



